module.exports = __webpack_public_path__ + "img/四校戦 4.f14a068a.jpg";